import type { SVGProps } from "react";
export interface MoneyChequeDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MoneyChequeDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MoneyChequeDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 8c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v8c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.876zm2.25 8A4.125 4.125 0 0 1 19 20.124H5a4.125 4.125 0 0 1-4.125-4.126V8A4.125 4.125 0 0 1 5 3.875h14A4.125 4.125 0 0 1 23.125 8z"
      />
      <path
        fill={color}
        d="M18 12.875a1.125 1.125 0 0 1 0 2.25h-2a1.125 1.125 0 0 1 0-2.25zm0-4 .116.005a1.126 1.126 0 0 1 0 2.239l-.116.005h-5a1.125 1.125 0 0 1 0-2.25zM6.797 10.278l.004.051.002.006.003.003.007.01q.013.015.054.046c.134.097.401.21.854.3 1.238.247 2.732 1.106 2.732 2.83 0 1.231-.782 2.224-1.843 2.64a1.122 1.122 0 0 1-2.219.024 2.9 2.9 0 0 1-1.714-1.608l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.122-.706l.043.107.03.075a.64.64 0 0 0 .187.218c.103.078.271.155.543.155.453 0 .703-.324.703-.6 0-.096-.028-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.584-.425-.997-1.076-.996-1.937q0-.053.004-.105l.002-.003c.046-1.16.853-1.984 1.837-2.342a1.124 1.124 0 0 1 2.218-.013c.84.298 1.427.921 1.715 1.608l.073.192.03.111a1.126 1.126 0 0 1-2.123.708l-.043-.107-.03-.075a.64.64 0 0 0-.187-.22c-.103-.077-.271-.155-.543-.155a.9.9 0 0 0-.573.185c-.113.094-.13.174-.13.213z"
      />
    </svg>
  );
}
